import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { assign, isEmpty, map } from "lodash";
import { request } from "../../../utils/Request";
import UrlHelper from "js-url-helper";
import qs from "qs";
import { Route, Routes } from "react-router-dom";
import { Toast } from "primereact/toast";
import LoadList from "./partials/LoadList";
import { loadLoadListState, saveLoadListState } from "../../../utils/listNavigation";

const DEFAULT_DROPDOWNS = {
    brands: [],
    models: [],
    routes: [],
    drivers: [],
    transportVehicles: [],
    providers: [],
    locations: [],
    clients: [],
    dealers: [],
    cities: [],
    countries: [],
    legalEntities: [],
    spotLoadStatuses: [],
    alpSpotLoadStatuses: [],
};

const url = new UrlHelper();

const Load = (props: any) => {
    const { t } = props;
    const toast = useRef(null);
    const [dropdowns, setDropdowns] = useState<any>(null);
    const [moduleState, setModuleState] = useState<any>({
        page: 1,
        per_page: 50,
        search: null,
        initialized: false,
    });

    const getDropdowns = async () => {
        try {
            const response = await request({
                url: '/suppliers/loads/create',
                params: {
                    type: 'list',
                }
            });
            const { data } = response.data;
            setDropdowns({
                clients: map(data.clients, (obj: any) => assign({}, obj, { key: obj.id, label: obj.name })),
                cities: data.cities,
                dealers: data.dealers,
                countries: data.countries,
                drivers: data.drivers,
                transportVehicles: data.transportVehicles,
                locations: data.locations,
                legalEntities: data.legalEntities,
                loadStatuses: data.loadStatuses,
                providers: data.providers,
                brands: data.brands,
                models: data.models,
                routes: data.routes,
            });
        } catch (e) {
            setDropdowns(DEFAULT_DROPDOWNS);
        } finally {
            // Restore page / search / tab from sessionStorage (survives detail navigation)
            const prevUrl = qs.parse(url.getSearchParam().prev_url ?? "");
            const saved = loadLoadListState();
            const tabFromUrl = url.getSearchParam().tab;
            const tab = tabFromUrl || saved.tab || "inbound";

            const state = saveLoadListState({
                ...saved,
                page: !isEmpty(prevUrl.page) ? url.getSearchParam().page : (saved.page || 1),
                per_page: !isEmpty(prevUrl.per_page) ? url.getSearchParam().per_page : (saved.per_page || 50),
                search: !isEmpty(prevUrl.search) ? url.getSearchParam().search : (saved.search || null),
                tab,
                initialized: true,
            });

            setModuleState(state);
        }
    };

    useEffect(() => {
        document.title = t("loads");

        async function init() {
            await getDropdowns();
        }

        init();
    }, []);

    const toastify = (message: any, color: string = 'info', summary: any = null) => {
        if ( toast && toast.current ) {
            // @ts-ignore
            toast.current.show({
                severity: color, summary: message, detail: summary,
            });
        }
    };

    const setQuery = (value: any) => {
        const state = saveLoadListState(value);
        setModuleState(state);
    };

    return (
        <div className={ "module-container" }>
            <Toast ref={ toast } baseZIndex={13000}/>
            <div className="layout-content">
                { ( moduleState && moduleState.initialized ) ?
                    <React.Fragment>
                        <Routes>
                            <Route path={ "/" } element={
                                <LoadList
                                    moduleState={ moduleState }
                                    dropdowns={ dropdowns }
                                    toastify={ toastify }
                                    setQuery={ setQuery }
                                /> } />
                        </Routes>
                    </React.Fragment>
                    : <h6>{ t('loading') }</h6> }
            </div>
        </div>
    );
};

export default withTranslation()(Load);
